import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStandardPost = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "20px",
	height: "20px",
	viewBox: "0 0 20 20",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Post type / Standard photo post" }), /* @__PURE__ */ _jsxs("g", {
		id: "Post-type-/-Standard-photo-post",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M2.5,5.75 C1.53350169,5.75 0.75,6.53350169 0.75,7.5 L0.75,15 C0.75,16.2426407 1.75735931,17.25 3,17.25 L17,17.25 C18.2426407,17.25 19.25,16.2426407 19.25,15 L19.25,7.5 C19.25,6.53350169 18.4664983,5.75 17.5,5.75 L15.7207592,5.75 C14.967506,5.75 14.298763,5.26799733 14.0605634,4.55339859 L13.7443357,3.60471529 C13.5741931,3.09428762 13.0965196,2.75 12.5584816,2.75 L7.44151844,2.75 C6.90348043,2.75 6.42580688,3.09428762 6.25566432,3.60471529 L5.93943655,4.55339859 C5.70123697,5.26799733 5.03249399,5.75 4.27924078,5.75 L2.5,5.75 Z",
			id: "Rectangle",
			stroke: "#FFFFFF",
			strokeWidth: 1.5
		}), /* @__PURE__ */ _jsx("circle", {
			id: "Oval",
			stroke: "#FFFFFF",
			strokeWidth: 1.5,
			cx: 10,
			cy: 11,
			r: 3.25
		})]
	})]
});
export default SvgStandardPost;
